import { useEffect } from "react";
import { useLocation } from "react-router";
import { setActiveLink } from "../../NavigationSlice_Store";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";

/** Routes that map onto a named navigation entry. */
const PATH_TO_LABEL: Record<string, string> = {
  "/": "Dashboard",
  "/deals": "Deals Discovery",
  "/draft": "Draft Editor",
};

/** Mirror the current route into the navigation slice. */
export function useActiveLinkSync(): void {
  const dispatch = useAppDispatch();
  const activeLink = useAppSelector((state) => state.navigationSlice.activeLink);
  const location = useLocation();

  useEffect(() => {
    const labelForPath = PATH_TO_LABEL[location.pathname];
    if (labelForPath && labelForPath !== activeLink) {
      dispatch(setActiveLink(labelForPath));
    }
  }, [location.pathname, activeLink, dispatch]);
}
